import AnalyticsIcon from "@mui/icons-material/Analytics"; 
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import "./DataScienceSection.css";

function DataScienceSection() {
    return (
        <section className="course-content-section data-science-section">

            <div className="content-layout">

                {/* =================================================
                    MAIN CONTENT
                ================================================== */}

                <div className="content-main">

                    {/* <div className="content-label">
                        DATA SCIENCE
                    </div> */}

                    <h3>
                        Turn Data Into
                        <span>
                            {" "}Business Decisions
                        </span>
                    </h3>

                    <p className="content-intro">
                        Combine statistics, programming and
                        business knowledge to solve
                        real-world problems using data.
                    </p>

                    <div className="benefits-grid">

                        <Benefit text="Strong demand for data professionals across industries." />

                        <Benefit text="Crucial for business decisions as organizations become increasingly data-driven." />

                        <Benefit text="Used across Finance, Marketing, Healthcare, Retail and Technology." />

                        <Benefit text="Combines Statistics, Coding and Business knowledge." />

                        <Benefit text="Ideal for analytical thinkers who enjoy solving problems with data." />

                    </div>

                </div>


                {/* =================================================
                    SIDE CONTENT
                ================================================== */}

                <div className="content-side">

                    <div className="side-card data-card">

                        <div className="side-card-icon">
                            <AnalyticsIcon />
                        </div>

                        <h4>
                            Data Science Training
                        </h4>

                        <p>
                            Learn the complete data science
                            workflow from data preparation
                            to predictive modeling.
                        </p>


                        <div className="data-stack">

                            <span>
                                Python
                            </span>

                            <span>
                                Statistics
                            </span>

                            <span>
                                SQL
                            </span>

                            <span>
                                ML
                            </span>

                            <span>
                                Visualization
                            </span>

                        </div>

                    </div>

                </div>

            </div>


           

        </section>
    );
}


/* =========================================================
   REUSABLE BENEFIT
========================================================= */

function Benefit({ text }) {

    return (
        <div className="benefit-item">

            <CheckCircleIcon />

            <span>
                {text}
            </span>

        </div>
    );
}


export default DataScienceSection;